
import pkHeader from  '../common/header/header.vue';
import Scroll from '../common/scroll'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default{
data(){
return {
title:'订单列表',
rightContentProps:false,
selected:"全部",
page:1,
isLoading:false,
total:1,
removeMore:false,
userToken:this.$until.getUrlParam('openId') || localStorage.getItem("cdqcp_opid") || localStorage.getItem("useCar_cdqcp_opid"),
records:[],
n:20,
activeColor:"#FF6E1F",
pulldown:true,
pullup:true,
docHeigh:document.body.clientHeight - 42,
}
},
components:{
pkHeader,
CellFormPreview,
Group,
Cell,
Scroll
},
created() {
this.probeType = 1
this.listenScroll = true
},
mounted(){
var appFlag = this.$until.getUrlParam('from')
var openId =  this.$until.getUrlParam("openId")
if (appFlag){
localStorage.setItem("appFrom",appFlag);
openId&&openId!=='null'&&localStorage.setItem("cdqcp_opid",openId);
}
this.$until.getUrlParam('channelName') && sessionStorage.setItem("channelTokenName",this.$until.getUrlParam('channelName'))
this.loadPage();
},
methods:{
goback(){
if("iOS" == localStorage.getItem("appFrom") || "Android" == localStorage.getItem("appFrom")){
location.href = "##backToVC=1";
}else{
if(window.CHANNELTOKEN === 'qdn'){
this.$until.getHomeUrl(this,true);
}else {
location.href="/orders/allorders";
}
}
},
updateOrder(n,orderState,carNo){
if(orderState == "compile"){
return "已完成"
}else if(orderState == "success"){
if(!carNo){
this.records[n].activeColor = '#FFA87A'
}
return carNo ? "已派车":"待派车"
}else if(orderState == "pending"){
return "待支付"
}else if(orderState == "refunded" || orderState == "expiration"){
return "已关闭"
}
},
onShortcutTouchStart(){
event.preventDefault();
},
toCall(){
location.href =  location.pathname+"#/pickupStation";
},
routerTo(v,bizType){
this.$router.push('/order/'+v+"/"+bizType)
},
loadData() {
console.log(this.page,this.total)
if(this.page>this.total){
this.pullup = false
return
}
this.pullup = true
this.page = this.page+1
console.log(this.page)
this.loadPage()



},
loadPage(v){
if(v){
this.page = 1
}
if (this.page > this.total){
return
}
var me = this;
this.$store.dispatch('showLoading')
this.$http.post(window.innerAPI + "?server=orderList",{
_p_from:localStorage.getItem("appFrom"),
userToken:this.userToken,
pageSize:10,
bizTypeStr:'4,7',
currentPage:this.page,
channelCode:localStorage.getItem('useCar_jb_channelCode')
}).then(res =>{
var num = 0;
console.log("res.data.data", res.data.data);

if (res.data.data.total > 0){
(this.page == 1 && res.data.data.total == 0) && (me.records = res.data.data);
me.records = this.page > 1 ? me.records : [];
num  =  this.page> 1 ? me.records.length:0;
for(var n = 0; n < res.data.data.list.length; n++) {

if(res.data.data.list[n].orderState != 'pending'){
res.data.data.list[n].bookDate = Date.parse1(res.data.data.list[n].bookDate).format('MM月dd日')
res.data.data.list[n].activeColor = res.data.data.list[n].orderState=='success'?"#42a220":"#6D6D6D";
me.records.push(res.data.data.list[n])
num++;
}

}
console.log("me.records",me.records);
me.total = res.data.data.pages
}
me.$store.dispatch('hideLoading')
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/order/list.vue